import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  id?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  actionText?: string;
  actionTo?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  id,
  eyebrow,
  title,
  desc,
  actionText,
  actionTo,
  align = 'left',
}: SectionHeadingProps) {
  const centered = align === 'center';
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'
      }`}
    >
      <div className={centered ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary-600">
            {centered ? null : <span className="h-px w-8 bg-primary-400" aria-hidden="true" />}
            {eyebrow}
          </p>
        )}
        <h2 id={id} className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {actionText}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}